module.exports = __webpack_public_path__ + "img/joinleftthree.10415074.png";